import React, { useState } from 'react';
import { downloadBackupFile } from '../../../actions/report-actions';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { formatTimestampAsDateWithTime } from '../../../utils/dates-utils';
import { VerticalAlignBottomOutlined } from '@material-ui/icons';
import { IconButton, Tooltip } from '@material-ui/core';
import CommonTable from '../../common/table/CommonTable';
import { FormattedMessage, useIntl } from 'react-intl';
import LoadingSnackbar from '../../common/LoadingSnackbar';
import { getMachineProperty } from '../../../utils/report-utils';
import { filesize } from 'filesize';

const useStyles = makeStyles(theme => ({
  tableWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
}));

const BACKUP_TABLE_CONFIG = (downloadBackup, setDownloadProgress, machines, formatMessage) => [
  {
    header: formatMessage({ id: 'field.cash.register', defaultMessage: 'Cash register' }),
    value: ({ MachineId }) => getMachineProperty(machines, MachineId, 'Name'),
  },
  {
    header: formatMessage({ id: 'description', defaultMessage: 'Description' }),
    value: ({ Description }) => Description,
  },
  {
    header: formatMessage({ id: 'date', defaultMessage: 'Date' }),
    value: ({ Date }) => formatTimestampAsDateWithTime(Date),
  },
  {
    header: formatMessage({ id: 'size', defaultMessage: 'Size' }),
    value: ({ SizeBytes }) => `${filesize(SizeBytes)}`,
  },
  {
    header: formatMessage({ id: 'file.name', defaultMessage: 'Name' }),
    value: ({ MachineId, FileName, Date }) => (
      <>
        {FileName}
        <Tooltip placement="right" title="Download file">
          <IconButton onClick={() => downloadBackup(MachineId, FileName, Date, setDownloadProgress)}>
            <VerticalAlignBottomOutlined />
          </IconButton>
        </Tooltip>
      </>
    ),
  },
];

const BackupTable = ({ backups, downloadBackupFile, machines }) => {
  const [loadingProgress, setLoadingProgress] = useState(null);
  const { formatMessage } = useIntl();
  const classes = useStyles();
  
  if (!backups) {
    return null;
  }
  
  const downloadBackup = (machineID, fileName, date, setLoadingProgress) => {
    return downloadBackupFile(machineID, fileName, date, setLoadingProgress);
  };
  
  return (
    <div className={classes.tableWrapper}>
      <CommonTable
        data={backups.sort(({ Date: dateA }, { Date: dateB }) => new Date(dateB) - new Date(dateA))}
        tableConfig={BACKUP_TABLE_CONFIG(downloadBackup, setLoadingProgress, machines, formatMessage)}
      />
      
      <LoadingSnackbar
        progress={loadingProgress}
        label={<FormattedMessage id="loading" defaultMessage="Loading" />}
      />
    </div>
  );
};

BackupTable.propTypes = {
  backups: PropTypes.array,
  downloadBackupFile: PropTypes.func,
};

const decorate = compose(
  connect(
    store => ({ machines: store.user.machines }),
    dispatch => bindActionCreators({ downloadBackupFile }, dispatch)),
);

export default decorate(BackupTable);



